import { injectable } from "inversify";
import RoleEntity from "../../entities/RoleEntity";
import ExceptionEntity from "../../entities/ExceptionEntity";
import { Either } from "fp-ts/lib/Either";
import RoleRepository from "../../repositories/RoleRepository";

interface props { roleRepository: RoleRepository }

@injectable()
export default class CreateRoleInfoUseCase {
    _roleRepository: RoleRepository;

    constructor(_: props) {
        this._roleRepository = _.roleRepository;
    }

    public call = (name: string, description: string, permissions: any[]) => new  Promise<Either<ExceptionEntity, string>>(async (resolve, reject) => {
        try {
            const response = await this._roleRepository.createRole(name, description, permissions);
            
            return resolve(response);
        } catch (error) {
            return reject();
        }
    });
};

export const CreateRoleInfoUseCaseName = "CreateRoleInfoUseCaseName";